export default __webpack_public_path__ + "static/media/graph_Icon.19f2746e.svg";